import APIClient from '@/shared/http/clients/api'

const resourceName = 'REInsumoOcorrencia'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const Post = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Post`, data, config)
const Put = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/Put`, data, config)
const GetByOccurenceById = (OccurenceId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetByOccurenceById/${OccurenceId}`, data, config)
// const GetTotalCusto = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/Get/GetTotalCusto`, data, config)
const GetTotalCusto = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Get/GetTotalCusto`, data, config) // By filtro
const GetCustosPdf = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Get/GetCustosPdf`, data, config) // By filtro
const GetCustosPatologiasPdf = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/Get/GetCustosPatologiasPdf`, data, config) // By filtro
const Delete = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/Delete/${id}`, data, config) // By filtro

const InputsOccurrenceRepository = {
  Post,
  GetByOccurenceById,
  GetCustosPdf,
  GetCustosPatologiasPdf,
  Put,
  GetTotalCusto,
  Delete

}

export default InputsOccurrenceRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/inputsoccurrence.js